import React from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { toast } from 'react-toastify';
import moment from 'moment';

import AcessosPortalServices from '../../services/acessosPortal';
import './styles.css';

// Quem entrou na area do formando (comissao e formandos) e o que abriu. O
// servidor grava cada login e cada tela; o administrador entrando como a
// comissao nao conta.

const PERIODOS = [7, 30, 90];

// Telas do portal (area_fomando/src/config/Router.js)
const TELAS = {
  '/': 'Início',
  '/contrato': 'Contrato',
  '/funcionalidades': 'Funcionalidades',
  '/avulsos': 'Avulsos',
  '/formandos': 'Formandos',
  '/distribuir-brindes': 'Distribuir brindes',
  '/distribuir-itens': 'Distribuir itens',
  '/comprar': 'Adesão / compra',
  '/meus-dados': 'Meus dados',
  '/meus-pedidos': 'Meus pedidos',
  '/pedidos-comissao': 'Pedidos da comissão',
  '/instagram': 'Instagram',
  '/entrega': 'Entrega',
  '/publicacoes': 'Publicações',
  '/aprovacao-convite': 'Aprovação do convite',
  '/cronograma': 'Cronograma',
  '/personalizacoes': 'Alpha Design',
  '/orientacoes-fotograficas': 'Orientações fotográficas',
  '/termo-aceite': 'Termo de aceite'
};

const APARELHOS = {
  celular: { rotulo: 'Celular', icone: 'fa-mobile' },
  tablet: { rotulo: 'Tablet', icone: 'fa-tablet' },
  computador: { rotulo: 'Computador', icone: 'fa-desktop' }
};

const FILTROS_DE_PESSOAS = {
  todos: 'Todos',
  entraram: 'Já entraram',
  nunca: 'Nunca entraram'
};

export function nomeDaTela (pagina) {
  if (!pagina) return '';
  if (TELAS[pagina]) return TELAS[pagina];
  if (pagina.indexOf('/publicacoes/') === 0) return 'Publicações';
  return pagina;
}

function mensagemDoErro (erro, padrao) {
  return (erro && erro.response && erro.response.data && erro.response.data.error) || padrao;
}

function data (valor) {
  return valor ? moment(valor).format('DD/MM/YYYY HH:mm') : null;
}

// "hoje", "ontem", "há 5 dias"
export function haQuanto (valor, agora = new Date()) {
  if (!valor) return null;
  const dias = moment(agora).startOf('day').diff(moment(valor).startOf('day'), 'days');
  if (dias <= 0) return 'hoje';
  if (dias === 1) return 'ontem';
  return `há ${dias} dias`;
}

class AcessosPortal extends React.Component {

  state = {
    dias: 30,
    busca: '',
    carregando: true,
    lista: { resumo: {}, itens: [], total: 0, pagina: 1, porPagina: 50 },
    contrato: null,
    detalhe: null,
    carregandoDetalhe: false,
    filtroPessoas: 'todos',
    buscaPessoa: ''
  }

  componentDidMount () {
    if (this.podeVer()) this.carregar(1);
  }

  // Administrador e orcamentista, as mesmas rotas liberadas no servidor
  // (routes.js, QUEM_VE_OS_EMAILS).
  podeVer () {
    return Boolean(this.props.usuario) && ['administrador', 'orc'].indexOf(this.props.usuario.tipo) > -1;
  }

  carregar (pagina) {
    const { busca, dias } = this.state;
    this.setState({ carregando: true });
    new AcessosPortalServices().listarContratos({ busca, dias, pagina }).then((lista) => {
      this.setState({ carregando: false, lista });
    }).catch((erro) => {
      this.setState({ carregando: false });
      toast.error(mensagemDoErro(erro, 'Não foi possível carregar os acessos do portal.'));
    });
  }

  abrir (contrato) {
    this.setState({ contrato, detalhe: null, carregandoDetalhe: true, filtroPessoas: 'todos', buscaPessoa: '' });
    new AcessosPortalServices().detalheDoContrato(contrato.contrato, { dias: this.state.dias }).then((detalhe) => {
      this.setState({ carregandoDetalhe: false, detalhe });
    }).catch((erro) => {
      this.setState({ carregandoDetalhe: false });
      toast.error(mensagemDoErro(erro, 'Não foi possível carregar os acessos do contrato.'));
    });
  }

  voltar () {
    this.setState({ contrato: null, detalhe: null });
  }

  mudarPeriodo (dias) {
    this.setState({ dias }, () => {
      if (this.state.contrato) this.abrir(this.state.contrato);
      this.carregar(1);
    });
  }

  pesquisar (evento) {
    evento.preventDefault();
    this.carregar(1);
  }

  _renderPeriodo () {
    return (
      <div className="ap-periodo" role="group" aria-label="Período">
        {PERIODOS.map((dias) => (
          <button
            key={dias}
            type="button"
            className={`btn btn-sm ${this.state.dias === dias ? 'btn-primary' : 'btn-default'}`}
            aria-pressed={this.state.dias === dias}
            onClick={() => this.mudarPeriodo(dias)}
          >
            {dias} dias
          </button>
        ))}
      </div>
    );
  }

  _renderCartoes (cartoes) {
    return (
      <div className="ap-cartoes">
        {cartoes.map((cartao) => (
          <div key={cartao.rotulo} className={`ap-cartao${cartao.alerta ? ' ap-cartao--alerta' : ''}`}>
            <span className="ap-cartao-numero">{cartao.valor}</span>
            <span className="ap-cartao-rotulo">{cartao.rotulo}</span>
          </div>
        ))}
      </div>
    );
  }

  _renderProporcao (entraram, total) {
    if (!total) return <span className="text-muted">sem formandos</span>;
    const porcento = Math.round((entraram / total) * 100);
    return (
      <span className="ap-proporcao" title={`${entraram} de ${total} formandos já entraram (${porcento}%)`}>
        <span className="ap-proporcao-texto">{entraram} de {total}</span>
        <span className="ap-barra" aria-hidden="true"><span style={{ width: `${porcento}%` }}></span></span>
      </span>
    );
  }

  _renderLista () {
    const { lista, carregando, dias } = this.state;
    const resumo = lista.resumo || {};
    return (
      <div>
        {this._renderCartoes([
          { valor: resumo.contratos || 0, rotulo: 'Contratos com acesso' },
          { valor: resumo.logins || 0, rotulo: 'Logins' },
          { valor: resumo.formandos || 0, rotulo: 'Formandos que entraram' },
          { valor: resumo.comissoes || 0, rotulo: 'Comissões que entraram' }
        ])}
        <form className="ap-filtros" onSubmit={this.pesquisar.bind(this)}>
          <div className="input-group ap-busca">
            <input
              type="text"
              className="form-control"
              placeholder="Número do contrato"
              aria-label="Número do contrato"
              value={this.state.busca}
              onChange={(e) => this.setState({ busca: e.target.value })}
            />
            <div className="input-group-btn">
              <button type="submit" className="btn btn-primary btn-flat"><i className="fa fa-search"></i> Buscar</button>
            </div>
          </div>
        </form>
        {carregando ? (
          <div className="ap-vazio"><i className="fa fa-spinner fa-spin"></i> Carregando os acessos…</div>
        ) : lista.itens.length === 0 ? (
          <div className="ap-vazio">Nenhum acesso nos últimos {dias} dias. Eles aparecem aqui quando a comissão ou os formandos entram no portal.</div>
        ) : (
          <div className="table-responsive">
            <table className="table table-hover ap-tabela">
              <thead>
                <tr>
                  <th>Contrato</th>
                  <th>Último acesso</th>
                  <th>Comissão</th>
                  <th>Formandos que já entraram</th>
                  <th className="ap-numero">Logins</th>
                  <th className="ap-numero">Pessoas</th>
                  <th><span className="sr-only">Ações</span></th>
                </tr>
              </thead>
              <tbody>
                {lista.itens.map((item) => (
                  <tr key={item.contrato} className="ap-linha" onClick={() => this.abrir(item)}>
                    <td><strong>{item.numero}</strong></td>
                    <td className="ap-data">{haQuanto(item.ultimo)} <span className="text-muted">· {data(item.ultimo)}</span></td>
                    <td>{item.ultimoDaComissao ? haQuanto(item.ultimoDaComissao) : <span className="ap-selo ap-selo--nao">não entrou no período</span>}</td>
                    <td>{this._renderProporcao(item.formandosQueEntraram, item.formandosCadastrados)}</td>
                    <td className="ap-numero">{item.logins}</td>
                    <td className="ap-numero">{item.pessoas}</td>
                    <td className="ap-acoes">
                      <button type="button" className="btn btn-default btn-xs" onClick={(e) => { e.stopPropagation(); this.abrir(item); }}>
                        <i className="fa fa-users"></i> Ver pessoas
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {this._renderPaginacao()}
      </div>
    );
  }

  _renderPaginacao () {
    const { lista, carregando } = this.state;
    const paginas = Math.max(1, Math.ceil((lista.total || 0) / (lista.porPagina || 50)));
    if (carregando || paginas <= 1) return null;
    return (
      <div className="ap-paginacao">
        <button type="button" className="btn btn-default btn-sm" disabled={lista.pagina <= 1} onClick={() => this.carregar(lista.pagina - 1)}>
          <i className="fa fa-chevron-left"></i> Anteriores
        </button>
        <span>Página {lista.pagina} de {paginas} · {lista.total} contratos</span>
        <button type="button" className="btn btn-default btn-sm" disabled={lista.pagina >= paginas} onClick={() => this.carregar(lista.pagina + 1)}>
          Próximos <i className="fa fa-chevron-right"></i>
        </button>
      </div>
    );
  }

  pessoasFiltradas () {
    const { detalhe, filtroPessoas, buscaPessoa } = this.state;
    const termo = buscaPessoa.trim().toLowerCase();
    return (detalhe ? detalhe.pessoas : []).filter((pessoa) => {
      if (filtroPessoas === 'entraram' && !pessoa.ultimoAcesso) return false;
      if (filtroPessoas === 'nunca' && pessoa.ultimoAcesso) return false;
      if (termo && `${pessoa.nome} ${pessoa.email || ''}`.toLowerCase().indexOf(termo) === -1) return false;
      return true;
    });
  }

  _renderAparelho (dispositivo) {
    const aparelho = APARELHOS[dispositivo];
    if (!aparelho) return <span className="text-muted">—</span>;
    return <span title={aparelho.rotulo}><i className={`fa ${aparelho.icone}`}></i> {aparelho.rotulo}</span>;
  }

  _renderDetalhe () {
    const { contrato, detalhe, carregandoDetalhe, filtroPessoas } = this.state;
    return (
      <div>
        <div className="ap-detalhe-topo">
          <button type="button" className="btn btn-default btn-sm" onClick={this.voltar.bind(this)}>
            <i className="fa fa-arrow-left"></i> Todos os contratos
          </button>
          <h4 className="ap-detalhe-titulo">
            Contrato <Link to={`/contratos/pesquisar?contrato=${contrato.numero}`} title="Abrir o contrato">{contrato.numero}</Link>
          </h4>
        </div>
        {carregandoDetalhe || !detalhe ? (
          <div className="ap-vazio"><i className="fa fa-spinner fa-spin"></i> Carregando as pessoas do contrato…</div>
        ) : (
          <div>
            {this._renderCartoes([
              { valor: `${detalhe.resumo.formandosQueEntraram} de ${detalhe.resumo.formandos}`, rotulo: 'Formandos que já entraram' },
              { valor: detalhe.resumo.nuncaEntraram, rotulo: 'Nunca entraram', alerta: detalhe.resumo.nuncaEntraram > 0 },
              { valor: haQuanto(detalhe.resumo.ultimoDaComissao) || 'nunca', rotulo: 'Último acesso da comissão' }
            ])}
            <div className="ap-filtros">
              <div className="btn-group" role="group" aria-label="Filtrar pessoas">
                {Object.keys(FILTROS_DE_PESSOAS).map((chave) => (
                  <button
                    key={chave}
                    type="button"
                    className={`btn btn-sm ${filtroPessoas === chave ? 'btn-primary' : 'btn-default'}`}
                    aria-pressed={filtroPessoas === chave}
                    onClick={() => this.setState({ filtroPessoas: chave })}
                  >
                    {FILTROS_DE_PESSOAS[chave]}
                  </button>
                ))}
              </div>
              <input
                type="text"
                className="form-control ap-busca-pessoa"
                placeholder="Nome ou e-mail"
                aria-label="Buscar pessoa"
                value={this.state.buscaPessoa}
                onChange={(e) => this.setState({ buscaPessoa: e.target.value })}
              />
            </div>
            <div className="table-responsive">
              <table className="table ap-tabela">
                <thead>
                  <tr>
                    <th>Pessoa</th>
                    <th>Curso</th>
                    <th>Último acesso</th>
                    <th>Primeiro acesso</th>
                    <th className="ap-numero">Logins</th>
                    <th className="ap-numero">No período</th>
                    <th>Mais abriu</th>
                    <th>Aparelho</th>
                  </tr>
                </thead>
                <tbody>
                  {this.pessoasFiltradas().map((pessoa) => (
                    <tr key={pessoa.perfil === 'comissao' ? 'comissao' : pessoa.formando} className={pessoa.ultimoAcesso ? '' : 'ap-linha--nunca'}>
                      <td>
                        <div className="ap-pessoa">
                          <strong>{pessoa.nome}</strong>
                          {pessoa.perfil === 'comissao' ? <span className="ap-selo ap-selo--comissao">comissão</span> : null}
                          {pessoa.membroComissao ? <span className="ap-selo ap-selo--membro">membro da comissão</span> : null}
                        </div>
                        {pessoa.email ? <div className="ap-email">{pessoa.email}</div> : null}
                      </td>
                      <td>{pessoa.curso || <span className="text-muted">—</span>}</td>
                      <td className="ap-data">
                        {pessoa.ultimoAcesso
                          ? <span>{haQuanto(pessoa.ultimoAcesso)} <span className="text-muted">· {data(pessoa.ultimoAcesso)}</span></span>
                          : <span className="ap-selo ap-selo--nao">nunca entrou</span>}
                      </td>
                      <td className="ap-data">{data(pessoa.primeiroAcesso) || <span className="text-muted">—</span>}</td>
                      <td className="ap-numero">{pessoa.logins}</td>
                      <td className="ap-numero">{pessoa.loginsNoPeriodo}</td>
                      <td>{pessoa.paginas.length ? pessoa.paginas.map((p) => nomeDaTela(p.pagina)).join(', ') : <span className="text-muted">—</span>}</td>
                      <td>{this._renderAparelho(pessoa.dispositivo)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {this.pessoasFiltradas().length === 0 ? <div className="ap-vazio">Ninguém neste filtro.</div> : null}
            {this._renderRecentes()}
          </div>
        )}
      </div>
    );
  }

  _renderRecentes () {
    const recentes = (this.state.detalhe && this.state.detalhe.recentes) || [];
    if (!recentes.length) return null;
    return (
      <div className="ap-recentes">
        <h5 className="ap-recentes-titulo">Últimos acessos</h5>
        <ul className="ap-linha-do-tempo">
          {recentes.map((acesso) => (
            <li key={acesso.id}>
              <span className="ap-data">{data(acesso.quando)}</span>
              <span><strong>{acesso.nome}</strong> {acesso.evento === 'login' ? 'entrou no portal' : <span>abriu <em>{nomeDaTela(acesso.pagina)}</em></span>}</span>
              {APARELHOS[acesso.dispositivo] ? <span className="text-muted"><i className={`fa ${APARELHOS[acesso.dispositivo].icone}`}></i></span> : null}
            </li>
          ))}
        </ul>
      </div>
    );
  }

  render () {
    if (!this.podeVer()) return <Redirect to="/unauthorized" />;
    return (
      <div className="ap-pagina">
        <div className="box">
          <div className="box-body">
            <div className="ap-cabecalho">
              <div>
                <h3 className="ap-titulo">Acessos do portal</h3>
                <p className="ap-subtitulo">
                  Quem entrou na área do formando (comissão e formandos) e o que abriu. O administrador entrando como a comissão não conta.
                </p>
              </div>
              <div className="ap-cabecalho-acoes">
                {this._renderPeriodo()}
                <a className="btn btn-default btn-sm" href="https://clarity.microsoft.com/projects" target="_blank" rel="noopener noreferrer" title="Gravações das sessões e mapa de cliques do portal">
                  <i className="fa fa-video-camera"></i> Gravações (Clarity)
                </a>
              </div>
            </div>
            {this.state.contrato ? this._renderDetalhe() : this._renderLista()}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario.autenticado
  };
};

export default connect(mapStateToProps)(AcessosPortal);



// WEBPACK FOOTER //
// ./src/views/AcessosPortal/index.js